/* Shopify sometimes renders market-subfolder pages (e.g. /hr-hr) with the wrong
   routes root (/en-hr/) for first-time visitors, so every internal link drops the
   visitor into another language. Right before a link is followed, rewrite its
   locale prefix to the one in the current URL. No-op when Shopify's root is correct. */
(function () {
  var LOCALE_SEGMENT = /^[a-z]{2}(-[a-z]{2})?$/i;
  var SKIP_FIRST_SEGMENT = /^(cdn|checkout|checkouts|apps|services|tools|customer_authentication|localization)$/i;

  var localeRoots = {};
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(function (link) {
    try {
      var segment = new URL(link.href).pathname.split('/')[1] || '';
      if (LOCALE_SEGMENT.test(segment)) localeRoots[segment.toLowerCase()] = true;
    } catch (e) {}
  });

  var current = (location.pathname.split('/')[1] || '').toLowerCase();
  if (!localeRoots[current]) return;

  var shopRoot = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/')
    .replace(/^\/+|\/+$/g, '')
    .toLowerCase();
  if (shopRoot === current) return;

  function localize(anchor) {
    if (anchor.hasAttribute('hreflang') || anchor.closest('form[action*="localization"]')) return;
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var url;
    try {
      url = new URL(href, location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== location.origin) return;

    var segments = url.pathname.split('/').slice(1);
    var first = (segments[0] || '').toLowerCase();
    if (first === current || SKIP_FIRST_SEGMENT.test(first)) return;
    if (localeRoots[first]) segments.shift();

    var rest = segments.join('/');
    url.pathname = '/' + current + (rest ? '/' + rest : '');
    anchor.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function onInteraction(event) {
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (anchor) localize(anchor);
  }

  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach(function (type) {
    document.addEventListener(type, onInteraction, true);
  });
})();
